import * as types from '../actions';

const initialState = {
    actionRequiredItems:{},
    clientActionRequiredItems:{},
    dashboardChartData:{},
    dashboardClientChartData:{},
    errorData:'',
    activity:'',
    status:'',
    shiftTimeChangeRequestCountData: {},
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 

    switch(action.type) {

        case types.DASHBOARD_ACTION_REQUIRED_LIST_SUCCESS:
            return {
                ...state,
                actionRequiredItems:response.data,
                status: response.status,  
                activity:types.DASHBOARD_ACTION_REQUIRED_LIST_SUCCESS+timeVar,                               
            };

        case types.DASHBOARD_CHART_DATA_LIST_SUCCESS:
            return {
                ...state,
                dashboardChartData:response.data,
                status: response.status,  
                activity:types.DASHBOARD_CHART_DATA_LIST_SUCCESS+timeVar,                               
            };
        case types.DASHBOARD_CLIENT_CHART_DATA_LIST_SUCCESS:
            return {
                ...state,
                dashboardClientChartData:response.data,
                status: response.status,  
                activity:types.DASHBOARD_CLIENT_CHART_DATA_LIST_SUCCESS+timeVar,                               
            };
        case types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_SUCCESS:
            return {
                ...state,
                clientActionRequiredItems:response.data,
                status: response.status,  
                activity:types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_SUCCESS+timeVar,                               
            };
        
        case types.SHIFT_TIME_CHANGE_REQUEST_COUNT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    shiftTimeChangeRequestCountData:response.data,
                    status: response.status,  
                    activity:types.SHIFT_TIME_CHANGE_REQUEST_COUNT_SUCCESS+timeVar,          
                };
            }
            else {
                return {
                    ...state,
                    errorData:response.data,
                    status: response.status,  
                    activity:types.SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR+timeVar,          
                };
            }
            case types.SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR:
                return {
                    ...state,
                    errorData:response.data,
                    status: response.status,  
                    activity:types.SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR+timeVar,          
                };

       
        default:
            return state;

    }
}